import vi from 'antd/lib/locale/vi_VN';
import jp from 'antd/lib/locale/ja_JP';
import en from 'antd/lib/locale/en_US';

export const LOCALES = {
	vi,
	jp,
	en,
};
